<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_22"></a><a id="pg22lev1"></a><img alt="Speedy chorizo and chickpea stew" src="images/f0022-01.jpg"/></h2>
<p class="recipe_hdnote">One of the great things about tapas is that they can be whipped up in a flash. This speedy little stew is at home on a table laden with a selection of tapas, or served as a tasty meal for two that can be ready in minutes.</p>
<div class="wrap">
<p class="image"><a id="page_23"></a><img alt="image" class="vertical" src="images/f0023-01.jpg"/></p>
</div>
<p class="yield">Serves 4 to 6 as a starter or 2 as a main</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 10 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 20 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="ingred_sublist">8 green onions</p>
<p class="ingred_sublist">1 tbsp olive oil</p>
<p class="ingred_sublist">1 tbsp finely chopped fresh rosemary leaves</p>
<p class="ingred_sublist">1 tsp smoked sweet paprika</p>
<p class="ingred_sublist">one 15-oz can chickpeas, drained and rinsed</p>
<p class="ingred_sublist">2 chorizo sausages</p>
<p class="ingred_sublist">2 tbsp sherry vinegar</p>
<p class="ingred_sublist">one 15-oz can tomatoes</p>
<p class="ingred_sublist">sea salt and freshly ground pepper</p>
<p class="method_txt">Chop the green onions into rounds, separating the white and green parts. Put the oil into a large frying pan over high heat. Add the white parts of the green onions, the rosemary, smoked paprika, and chickpeas to the pan and fry for 2 minutes.</p>
<p class="method_txt">Slice the chorizo into <sup>1</sup>/<sub>8</sub>-in-thick rounds, add to the pan, and cook for 2 minutes. Add the sherry vinegar, turn down the heat, and cook gently, uncovered, stirring occasionally, for 5 minutes.</p>
<p class="method_txt">Add the tomatoes and cook for 10 minutes. Taste for salt and pepper and adjust if necessary.</p>
<p class="method_txt">Finish the stew with the green tops of the green onions, sprinkling them over just before serving.</p>
<div class="wrap">
<p class="image"><img alt="image" class="vertical" src="images/f0022-02.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11-chapter05.vue?bc23cc08